<template>
  <div class="d-flex flex-column flex-root" v-loading="loading">
    <div
      class="login login-1 d-flex flex-column flex-lg-row flex-column-fluid bg-white login-signin-on"
      id="kt_login"
    >
      <!--begin::Aside-->
      <div
        class="login-aside d-flex flex-column flex-row-auto"
        style="background-color: #f2c98a"
      >
        <div class="d-flex flex-column-auto flex-column pt-lg-40 pt-15">
          <a href="#" class="text-center mb-10">
            <img src="media/logos/logo-letter-1.png" class="max-h-70px" alt="" />
          </a>
        </div>
        <div
          class="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center"
          :style="{ backgroundImage: `url(${backgroundImage})` }"
        ></div>
      </div>
      <!--begin::Aside-->
      <!--begin::Content-->
      <div
        class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto"
      >
        <div class="d-flex flex-column-fluid flex-center">
          <!--begin::Signin-->
          <div class="login-form login-signin">
            <div class="pb-13 pt-lg-0 pt-5">
              <h3 class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg">
                管理者ログイン
              </h3>
            </div>
            <div v-if="step == 1">
              <form class="form" id="kt_login_signin_form" v-on:submit.prevent="submit">
                <div class="form-group">
                  <label class="font-size-h6 font-weight-bolder text-dark"
                    ><span class="star">*</span>メールアドレス</label
                  >
                  <div id="example-input-group-1" label="" label-for="example-input-1">
                    <input
                      class="form-control form-control-solid h-auto py-7 px-6 rounded-lg"
                      type="text"
                      name="email"
                      ref="email"
                      v-model="form.email"
                      maxlength="200"
                    />
                    <div class="error-message" v-if="error.email">
                      {{ error.email[0] }}
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="d-flex justify-content-between mt-n5">
                    <label class="font-size-h6 font-weight-bolder text-dark pt-5"
                      ><span class="star">*</span>パスワード</label
                    >
                  </div>
                  <div id="example-input-group-2" label="" label-for="example-input-2">
                    <input
                      class="form-control form-control-solid h-auto py-7 px-6 rounded-lg"
                      type="password"
                      name="password"
                      ref="password"
                      maxlength="200"
                      v-model="form.password"
                      autocomplete="off"
                    />
                    <div class="error-message" v-if="error.password">
                      {{ error.password[0] }}
                    </div>
                  </div>
                </div>
                <div class="mt-5 mb-5 text-right">
                  <router-link
                    class="text-primary font-size-h6 font-weight-bolder text-hover-primary pt-5 cursor-pointer"
                    id="kt_login_forgot"
                    :to="routeForgotPassword"
                    >PW再設定</router-link
                  >
                </div>
                <div class="pb-lg-0 pb-5">
                  <button
                    :disabled="isButtonDisabledLogin"
                    type="submit"
                    ref="kt_login_signin_submit"
                    class="btn btn-primary font-weight-bolder font-size-h6 px-15 py-4 my-3 mr-3"
                  >
                    ログイン
                  </button>
                </div>
                <input type="hidden" name="_csrf" v-model="form._csrf" />
              </form>
            </div>
            <div v-else>
              <form id="verify-submit" v-on:submit.prevent="submitVerify">
                <div class="form-group">
                  <label class="font-size-h6 font-weight-bolder text-dark"
                    ><span class="star">*</span
                    >電話番号に送信された認証コードを入力してください。</label
                  >
                  <div class="pt-4">
                    <input
                      class="form-control form-control-solid h-auto py-7 px-6 rounded-lg"
                      type="text"
                      name="email"
                      ref="email"
                      v-model="form.sns_code"
                      maxlength="6"
                    />
                    <div class="error-message" v-if="error.sns_code">
                      {{ error.sns_code[0] }}
                    </div>
                  </div>
                </div>
                <div class="mt-5 mb-5 text-right">
                  <span v-if="countdown != 0"
                    >{{ countdown }}秒後に認証コードが再送できます。</span
                  >
                  <h3
                    v-if="countdown == 0"
                    :disabled="isButtonDisabled"
                    class="text-primary font-size-h6 font-weight-bolder text-hover-primary pt-5 cursor-pointer"
                    @click="renewSms"
                  >
                    認証コードを再送します。
                  </h3>
                </div>
                <div class="pb-lg-0 pb-5">
                  <button
                    type="submit"
                    ref="verify-submit"
                    class="btn btn-primary font-weight-bolder font-size-h6 px-15 py-4 my-3 mr-3"
                  >
                    ログイン
                  </button>
                </div>
                <input type="hidden" name="_csrf" v-model="form._csrf" />
              </form>
            </div>
          </div>
          <!--end::Signin-->
        </div>
      </div>
      <!--end::Content-->
    </div>
    <my-dialog
      v-on:submit="popup = false"
      v-bind:dialog="popup"
      :closeOnClickModal="false"
      width="20%"
      v-bind:btnOk="$t('DIALOG.BTN_OKIE_PERMISSON_DENIED')"
      :showCancelButton="false"
    >
      <template slot="header">
        <div class="textwidget text-center">
          {{ contentPoopup }}
        </div>
      </template>
    </my-dialog>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import routeTenant from "@/core/services/routeTenant.service";

// FormValidation plugins
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";

import KTUtil from "@/assets/js/components/util";
import { mapGetters, mapState, mapActions } from "vuex";
import { LOGIN, LOGOUT, CALL_CSRF_TOKEN, getCsrfRandom } from "@/core/services/store/auth.module";
import { STATUS_CODE } from "@/core/config/constant";
import { SET_TITLE_BUSINESS } from "@/core/services/store/business.module";
import apiService from "@/core/services/api.service";

const tenant_code = routeTenant.getTenant();
export default {
  name: "login-1",
  data() {
    return {
      // Remove this dummy login info
      loading: false,
      form: {
        email: "",
        password: "",
        sns_code: "",
        tenant_code: tenant_code,
        session_otp: "",
        _csrf: "",
      },
      errorMessage: "",
      error: {},
      routeForgotPassword: { name: "forgot-password" },
      popup: false,
      isButtonDisabled: false,
      isButtonDisabledLogin: false,
      contentPoopup: "",
      countdown: 0,
      intervalId: null,
      step: 1,
    };
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    ...mapGetters(["currentUser", "getSCRFToken"]),
    backgroundImage() {
      return process.env.BASE_URL + "media/svg/illustrations/login-visual-1.svg";
    },
  },
  mounted() {
    // this.startCountdown(150);
    this[CALL_CSRF_TOKEN]();
    this.form._csrf = getCsrfRandom();
  },
  created() {},
  methods: {
    ...mapActions([CALL_CSRF_TOKEN]),
    showForm(form) {
      this.state = form;
      var form_name = "kt_login_" + form + "_form";
      KTUtil.animateClass(
        KTUtil.getById(form_name),
        "animate__animated animate__backInUp"
      );
    },
    submit() {
      if (!this.isButtonDisabledLogin) {
        this.isButtonDisabledLogin = true;
        const tenant_code = routeTenant.getTenant();
        this.error = {};
        this.errorMessage = "";
        var email = this.form.email;
        var password = this.form.password;
        const _csrf = this.form._csrf;
        let param = { email, password, tenant_code, _csrf };
        // clear existing errors
        this.$store.dispatch(LOGOUT);
        // set spinner to submit button
        const submitButton = this.$refs["kt_login_signin_submit"];
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        setTimeout(() => {
          // send login request
          apiService
            .post(`auth/login`, param)
            .then((response) => {
              if (response.data.code == 422) {
                if (
                  response.data &&
                  response.data.data &&
                  response.data.data.tenant_code &&
                  response.data.data.tenant_code[0]
                ) {
                  this.popup = true;
                  this.contentPoopup = response.data.data.tenant_code[0];
                } else if (
                  response.data &&
                  response.data.data.poopup_err &&
                  response.data.data.poopup_err[0]
                ) {
                  this.popup = true;
                  this.contentPoopup = response.data.data.poopup_err[0];
                } else this.error = response.data.data;
              }
              if (response.data.code == 403) {
                this.$router.push({
                  name: "reset-password",
                  query: { token: response.data.data, flag: 1 },
                });
              }
              if (response.data.code == 400 || response.data.code == 404) {
                this.notifyError(response.data.data);
              }
              if (response.data.code == 200) {
                this.step = 2;
                this.form.session_otp = response.data.data.session;
                this.startCountdown(30);
              }
            })
            .catch((e) => {
              this.notifyError(e);
            });

          submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
        }, 1000);
        setTimeout(() => {
          this.isButtonDisabledLogin = false;
        }, 1000);
      }
    },
    submitVerify() {
      this.error = {};
      this.loading = true;
      this.$store
        .dispatch(LOGIN, this.form)
        // go to which page after successfully login
        .then((response) => {
          this.loading = false;
          if (response.code == 422) {
            if (
              response.data &&
              response.data.tenant_code &&
              response.data.tenant_code[0]
            ) {
              this.popup = true;
              this.contentPoopup = response.data.tenant_code[0];
            } else if (
              response.data &&
              response.data.poopup_err &&
              response.data.poopup_err[0]
            ) {
              this.popup = true;
              this.contentPoopup = response.data.poopup_err[0];
            } else this.error = response.data;
          }
          if (response.code == 403) {
            this.$router.push({
              name: "reset-password",
              query: { token: response.data, flag: 1 },
            });
          }
          if (response.code == 400) {
            this.notifyError(response.data);
          }
          if (response.data.token && response.code == 200) {
            // this.$store.dispatch(SET_TITLE_BUSINESS)
            if (
              response.data.user &&
              response.data.user.super_user &&
              response.data.user.super_user == 1
            ) {
              this.$router.push({ name: "top" });
            } else this.$router.push({ name: "subcontractor" });
          }
        })
        .catch((e) => {
          this.loading = false;
          this.notifyError(e);
        });
    },
    renewSms() {
      if (!this.isButtonDisabled) {
        this.isButtonDisabled = true;
        this.loading = true;
        apiService
          .post(`auth/renew-code`, this.form)
          .then((response) => {
            this.loading = false;
            if (response.data.code == 422) {
              if (
                response.data &&
                response.data.data &&
                response.data.data.tenant_code &&
                response.data.data.tenant_code[0]
              ) {
                this.popup = true;
                this.contentPoopup = response.data.data.tenant_code[0];
              } else if (
                response.data &&
                response.data.data.poopup_err &&
                response.data.data.poopup_err[0]
              ) {
                this.popup = true;
                this.contentPoopup = response.data.data.poopup_err[0];
              } else this.error = response.data.data;
            }
            if (response.data.code == 403) {
              this.$router.push({
                name: "reset-password",
                query: { token: response.data.data, flag: 1 },
              });
            }
            if (response.data.code == 400 || response.data.code == 404) {
              this.notifyError(response.data.data);
            }
            if (response.data.code == 200) {
              this.form.sns_code = "";
              this.form.session_otp = response.data.data.session;
              this.notifySuccess("操作が成功しました。");
              this.startCountdown(30);
            }
          })
          .catch((e) => {
            this.loading = false;
            this.notifyError(e);
          });
        setTimeout(() => {
          this.isButtonDisabled = false;
        }, 3000); // Thời gian chờ 1 giây (tùy chỉnh theo nhu cầu của bạn)
      }
    },

    startCountdown(duration) {
      let timeRemaining = duration;

      this.countdown = this.formatTime(timeRemaining);

      this.intervalId = setInterval(() => {
        timeRemaining--;

        if (timeRemaining < 0) {
          clearInterval(this.intervalId);
          this.countdown = 0;
        } else {
          this.countdown = this.formatTime(timeRemaining);
        }
      }, 1000);
    },
    formatTime(time) {
      const minutes = Math.floor(time / 60);
      const seconds = time % 60;

      return `${seconds < 10 ? "0" : ""}${seconds}`;
      // return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
    this.countdown = 0;
  },
};
</script>

<style scoped>
.star {
  content: "*";
  color: #f56c6c !important;
  margin-right: 4px;
}
.error-message {
  color: red;
}
</style>
